import { useTranslation } from "react-i18next";

import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";
import { SkeletonNote } from "@/blocks/SkeletonNote";

import { useCreateNote } from "@/hooks/useCreateNote/useCreateNote";
import { NotesList } from "../NotesList";
import { SectionNotesForm } from "../SectionNotesForm";

import { DisplayContentProps } from "./SectionNotes.decl";

import { useGetTagsAndNotes } from "@/hooks/useGetTagsAndNotes/useGetTagsAndNotes";
import { usePathParams } from "@/states/path_param";

function DisplayContent({ notes }: DisplayContentProps) {
  const { handleOnSubmit } = useCreateNote();

  if (!notes.length) {
    return <SectionNotesForm onSubmit={handleOnSubmit} show />;
  }

  return <NotesList notes={notes} />;
}

export function SectionNotes() {
  const { t } = useTranslation();
  const { callId } = usePathParams();

  const { notes, loading } = useGetTagsAndNotes({ callId });

  if (loading) {
    return <SkeletonNote />;
  }

  if (!notes) {
    return null;
  }

  return (
    <Section data-test="notes-section">
      <SectionHeader>
        <SectionTitle>{t("call_context.notes")}</SectionTitle>
      </SectionHeader>
      <DisplayContent notes={notes} />
    </Section>
  );
}
